import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8dab918e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8dab918e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dab918e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dab918e')) {
      api.createRecord('8dab918e', component.options)
    } else {
      api.reload('8dab918e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8dab918e&scoped=true", function () {
      api.rerender('8dab918e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/clientAccounts/index.vue"
export default component.exports